import requests from "./api/base-api";
import {data} from "react-router-dom";

const NewsService = {
  getAllNews: (params) => requests.getByParams(`/news/v1/get-all-news-for-user`,params),
  // LikeNews: (params) => requests.post(`/news/v1/news-like`,params),
  // DisLikeNews: (params) => requests.post(`/news/v1/news-dislike`,params),
  getDetail:(id) => requests.getByParams(`/news/v1/get-news-for-user/${id}`),

  getCommentsById: (newsId) => requests.getByParams(`/comment/get-all/${newsId}`),

  sendComment: (data) => requests.post(`/comment/comment-create-news`, data),

  LikeNews: (data) => requests.post(`/news/v1/news-like`, data),
  DisLikeNews: (data) => requests.post(`/news/v1/news-dislike`, data),

  GetAllRegions: (params) => requests.get(`/news/v1/get-all-regions`, params)

};

export default NewsService;